import React from 'react';
import SafeIcon from '../common/SafeIcon';

export const Card = ({ children, className = '' }) => (
  <div className={`bg-[#0F1626] border border-slate-800 rounded-xl overflow-hidden shadow-lg ${className}`}>
    {children}
  </div>
);

export const Badge = ({ type, children }) => {
  const styles = {
    High: 'bg-red-500/10 text-red-400 border-red-500/20',
    Medium: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
    Low: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    critical: 'bg-red-500/10 text-red-400 border-red-500/20',
    warning: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
    safe: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    default: 'bg-slate-500/10 text-slate-400 border-slate-500/20'
  };
  
  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles[type] || styles.default}`}>
      {children}
    </span>
  );
};

export const Button = ({ children, variant = 'primary', className = '', onClick, disabled }) => {
  const variants = {
    primary: 'bg-yellow-400 hover:bg-yellow-500 text-[#0A0F1C] font-bold shadow-[0_0_15px_rgba(250,204,21,0.3)]',
    secondary: 'bg-slate-800 hover:bg-slate-700 text-white border border-slate-700',
    outline: 'bg-transparent border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400/10'
  };

  return (
    <button 
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};